import React from "react";
import { connect } from "react-redux";
import { PageTabs } from "../../../../../../store/AppDisplays";
import { isRemoteLoading, ReduxState } from "../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { Results } from "../../../02-pages/Results";
import * as InvoiceTypes from "../../../../../../store/Invoice/Types";
import { InvoiceType } from "../../../../../../store/Invoice/Types";
import { ClaimInvoiceStatus } from "../../../../../../store/ClaimMatch/Types";
import { Filter } from "../../../02-pages/Filter";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

interface OwnProps {
    statementLineId: string;
}

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: InvoiceTypes.Invoices;
}

type Props = OwnProps & StateProps;

/**
 *
 * @param s
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.INVOICE_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.INVOICE_RESULTS),
});

/**
 *
 * @param props
 */
export class ClaimsComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <Div style={{marginTop: "-20px"}}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.MANUAL_BOOKING_CREATE_BOOK_CLAIMS}
                    defaultFilters={{
                        invoiceStatus: `${ClaimInvoiceStatus.UNPAID},${ClaimInvoiceStatus.PARTIALLY_PAID}`,
                        invoiceType: InvoiceType.ClaimInvoice,
                    }}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.MANUAL_BOOKING_CREATE_BOOK_CLAIMS}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const Claims = connect(
    mapStateToProps,
    {},
)(ClaimsComp);
